// This file is automatically generated from ingestAssets.mjs
import * as React from 'react';
import IconContainer, { IconProps } from '../../../components/IconContainer';

export function IdentificationCardBoldIcon(props: IconProps) {
	return (
		<IconContainer {...props}>
			{
				<svg
					xmlns="http://www.w3.org/2000/svg"
					width="100%"
					height="100%"
					fill="none"
					viewBox="0 0 32 32"
				>
					<path
						fill="currentColor"
						d="M18 13.5a1.5 1.5 0 0 1 1.5-1.5h4a1.5 1.5 0 1 1 0 3h-4a1.5 1.5 0 0 1-1.5-1.5Zm1.5 6.5h4a1.5 1.5 0 1 0 0-3h-4a1.5 1.5 0 1 0 0 3Zm10-13v18a2.5 2.5 0 0 1-2.5 2.5H5A2.5 2.5 0 0 1 2.5 25V7A2.5 2.5 0 0 1 5 4.5h22A2.5 2.5 0 0 1 29.5 7Zm-3 .5h-21v17h21v-17ZM6.785 19.921c.36-.852.93-1.599 1.656-2.171a4.5 4.5 0 1 1 7.118 0 5.48 5.48 0 0 1 1.657 2.171 1.5 1.5 0 0 1-2.769 1.158C14.06 20.149 13.053 19.5 12 19.5c-1.053 0-2.059.65-2.449 1.579a1.5 1.5 0 1 1-2.766-1.158ZM10.5 15a1.5 1.5 0 1 0 3 0 1.5 1.5 0 0 0-3 0Z"
					/>
				</svg>
			}
		</IconContainer>
	);
}
